module.exports = __webpack_public_path__ + "static/media/moore.78261f8c.png";